import $ from 'jquery';
import jQuery from 'jquery';
import CONFIG from '../config';
import React  from 'react';
import "../index.css";
import * as Utils from '../lib/utils';

require('bootstrap-toggle');

window.jQuery = jQuery;
require("jsgrid");

const API_HOST = CONFIG.API_HOST;

class ReferenceForm extends React.Component{
    constructor(props) {
        super(props);
        this.gridRef = React.createRef();

        const params = Utils.getParams();

        this.state = {
            candidate : null,
            reference : null,
            otherRelationClass : "hidden",
            tokenFound : params.token ? true : false,
            token : params.token,
            messageBlockDisplayStatus : false,
            messagesToDisplay : [],
            minCharacterLimit : 10,
            characterLengthIndicatorData : {}
        };
    }

    componentDidMount() {

        const params = Utils.getParams();

        $.ajax({
            url: API_HOST + "/reference_data?token=" + params.token,
            dataType: "json",
            data: null
        }).then((referencesResult)=>{

            // console.log("referencesResult", referencesResult);

            if(referencesResult && referencesResult.status){

                if(referencesResult.status === "UNAVAILABLE"){
                    this.setState({
                        referenceMessage : "Reference has already been completed."
                    });
                }

            }else{

                $.ajax({
                    url: API_HOST + "/candidate_data/" + referencesResult[0].candidate_id,
                    dataType: "json",
                    data: null
                }).then((candidateResult)=>{
    
                    this.setState({
                        candidate : candidateResult,
                        reference : referencesResult[0]
                    })
    
                });
    
            }

        });
        
    }

    getContactTypeQuestions(type) {
        // console.log("type", type);

        const contactTypeQuestions = {
            academic : [
                {question: "How long and in what capacity have you known the candidate?", useCharLimit: true},
                {question: "What were the individual’s title and responsibilities at the time that you worked together (EX: student, T.A, R.A., etc.)?", useCharLimit: true},
                {question: "What are their strengths?", useCharLimit: true},
                {question: "What are their areas of improvement or weaknesses?", useCharLimit: true},
                {question: "How did they manage completing assignments and deadlines?", useCharLimit: true},
                {question: "Were they more of an individual contributor or team-oriented? Why do you think this?", useCharLimit: true},
                {question: "Did the individual complete any special projects or have any major accomplishments?", useCharLimit: true},
                {question: "Describe the individual’s communication style. Did the individual communicate effectively, verbally and in writing?", useCharLimit: true},
                {question: "What type of advice would you give their next employer to ensure success?", useCharLimit: true},
                {question: "Is there anything I haven’t asked that you’d like hiring team to be aware of?", useCharLimit: true}
            ],
            supervisor : [
                {question: "How long and in what capacity have you known the candidate?", useCharLimit: true},
                {question: "What were the individual's title and responsibilities at the time the two of you worked together?", useCharLimit: true},
                {question: "How did they perform in their role?", useCharLimit: true},
                {question: "What was it like to manage them? How much direction/oversight did they need?", useCharLimit: true},
                {question: "How do they handle new challenges?", useCharLimit: true},
                {question: "How did they respond to feedback?", useCharLimit: true},
                {question: "What are their strengths?", useCharLimit: true},
                {question: "What are their areas of improvement or weaknesses?", useCharLimit: true},
                {question: "Did the individual communicate effectively, verbally and in writing?", useCharLimit: true},
                {question: "Were they more of an individual contributor or team-oriented? Why do you think this?", useCharLimit: true},
                {question: "Did the individual complete any special projects or have any major accomplishments?", useCharLimit: true},
                {question: "What advice would you give their next employer to ensure success?", useCharLimit: true},
                {question: "Reason for leaving: Voluntary or involuntary? Explain.", useCharLimit: true},
                {question: "Is there any reason why your company would not rehire this individual? If yes, explain.", useCharLimit: true},
                {question: "Is there anything I haven’t asked that you’d like hiring team to be aware of?",  useCharLimit: true}
            ],
            // client : [
            //     {question: "How long and in what capacity have you known the candidate?", useCharLimit: true},
            //     {question: "Please describe the type of work and the timeframe in which the candidate performed work for you.", useCharLimit: true},
            //     {question: "How would you describe the candidate's ethics and value system?", useCharLimit: true},
            //     {question: "Please describe the candidate's quality of work and the relationship you built with them.", useCharLimit: true},
            //     {question: "Tell me about the candidate's ability to effectively manage stressful or crisis situations.", useCharLimit: true},
            //     {question: "Did the individual communicate and present themselves professionally, verbally and in writing?", useCharLimit: true},
            //     {question: "How would you describe the candidate's availability/dependability relative to you and your needs?", useCharLimit: true},
            //     {question: "Did the candidate successfully drive projects to completion on-time and on budget? If so, please provide an example.", useCharLimit: true},
            //     {question: "What would you categorize as the candidate's strengths?", useCharLimit: true},
            //     {question: "What would you categorize as the candidate's weaknesses?", useCharLimit: true},
            //     {question: "(If applicable) What was the reason this client relationship ended?", useCharLimit: true},
            //     {question: "Would you work with this candidate again?", useCharLimit: true},
            //     {question: "Is there anything I haven't asked that you'd like hiring team to be aware of?", useCharLimit: true},
            // ],
            peer : [
                {question: "How long and in what capacity have you known the candidate?", useCharLimit: true},
                {question: "What was the candidate’s title during this time?", useCharLimit: true},
                {question: "Please describe the candidate’s job duties.", useCharLimit: true},
                {question: "How well did the candidate perform in they role?", useCharLimit: true},
                {question: "How would you characterize the candidate’s teamwork and independent work skills? Were they able to collaborate and communicate?", useCharLimit: true},
                {question: "Describe a situation where you and the candidate disagreed? What happened? How was it resolved?", useCharLimit: true},
                {question: "How would you describe the candidate’s decision-making skills?", useCharLimit: true},
                {question: "How well did they manage crisis, pressure or stress?", useCharLimit: true},
                {question: "What are the candidate’s strengths?", useCharLimit: true},
                {question: "What are the candidate areas to improve on?", useCharLimit: true},
                {question: "Is there anything I haven’t asked that you’d like hiring team to be aware of?", useCharLimit: true},
            ]
        };
        return contactTypeQuestions[type];
    }


    validateResponses() {
        let validationMessages = [];
        const userResponses = $(".responseJSONItem");
        for(let i=0;i<userResponses.length;i++){
            const thisResponseObject = $(userResponses[i]);
            // console.log("thisResponseObject", thisResponseObject, thisResponseObject[0]);
            const usesLimit = thisResponseObject.hasClass("usesLimit");
            const thisResponseText = thisResponseObject.val();
            const responseId = thisResponseObject[0].id;
            const questionNumber = responseId.split("-")[1];
            const thisQuestion = $("#userQuestion-"+questionNumber).text();
            // console.log("thisQuestion", thisQuestion, "thisResponseText", thisResponseText)
            if(usesLimit && thisResponseText.length < 10){
                validationMessages.push("Response to question \""+thisQuestion+"\" must meet character limit.")
            }
        }

        if(validationMessages.length){
            return {
                isValidResults : false,
                messages : validationMessages
            };
        }else{
            return {
                isValidResults : true
            };
        }        
    }    

    validateAndSave() {
        const validationResult = this.validateResponses();
        console.log("validationResult", validationResult);
        // console.log("REFERENCES", this.state.references);
        if(validationResult.isValidResults){
            this.saveReference()
        }else{
            this.displayMessages(validationResult.messages)
        }
    }    

    saveReference() {

        // console.log("this.state", this.state);

        let saveUrl = API_HOST + "/reference_data";
        let method = "post";
        let referenceToSave = {
            reference_is_done : true,
            reference_done_datetime : (new Date()).toLocaleString("en-US"), //,
            candidate_id: this.state.candidate.id,
            reference_type: $('#relationshipType').find(":selected").val(),
            company_name: $('#companyName').val(),  
            phone: $('#phone').val(),
            email: $('#email').val(),
            details: $('#details').val(),
        }

        // console.log("responseJSONItem", $(".responseJSONItem"));

        let repsonsesJSON = [];
        const userResponses = $(".responseJSONItem");
        for(let i=0;i<userResponses.length;i++){
            // console.log("$(userResponses[i])", $(userResponses[i]));
            const thisResponseObject = $(userResponses[i]);
            const thisResponseText = thisResponseObject.val();
            const responseId = thisResponseObject[0].id;
            const questionNumber = responseId.split("-")[1];
            const thisQuestion = $("#userQuestion-"+questionNumber).text();
            repsonsesJSON.push([
                thisQuestion, thisResponseText
            ])
        }
        // console.log("repsonsesJSON", repsonsesJSON);
        referenceToSave.responses_json = JSON.stringify(repsonsesJSON);

        if(this.state.reference.id){
            referenceToSave["id"] = this.state.reference.id;
            referenceToSave["reference_first_name"] = this.state.reference.first_name;
            referenceToSave["reference_last_name"] = this.state.reference.last_name;
            method = "put";
        }
        // console.log("saveUrl", saveUrl);
        // console.log("method", method);
        // console.log("referenceToSave", referenceToSave);

        $.ajax({
            method: method,
            url: saveUrl,
            dataType: "json",
            data: referenceToSave
        }).then(()=>{
            alert("Save complete");

            this.setState({
                referenceMessage : "Your reference has been saved, you may close this window.",
                reference : null
            });

        });

        // alert("SAVE DISABLED, SEE CONSOLE")

        return false;
    }


    updateCharacterLengthIndicator(event, inputId) {
        let tempCharacterData = Utils.copy(this.state.characterLengthIndicatorData);
        if(!tempCharacterData[inputId]){
            tempCharacterData[inputId] = {};
        }
        
        tempCharacterData[inputId].numChars = event.target.value ? event.target.value.length : 0;
        tempCharacterData[inputId].indicatorColor = 
            tempCharacterData[inputId].numChars < this.state.minCharacterLimit ? 
                "#F00" : 
                "#0F0";
        
        tempCharacterData[inputId].indicatorWidth = 
            tempCharacterData[inputId].numChars < this.state.minCharacterLimit ? 
                ((tempCharacterData[inputId].numChars * 10) + "px") : 
                ((this.state.minCharacterLimit * 10) + "px");
        
        this.setState({
            characterLengthIndicatorData : tempCharacterData
        });
    }

    renderContactTypeQuestions() {
        
        const referenceType = this.state.reference && this.state.reference.reference_type ? 
            this.state.reference.reference_type : "peer";
        const userSpecificQuestions = this.getContactTypeQuestions(referenceType);

        // console.log("userSpecificQuestions", userSpecificQuestions);

        let questionsJSX = [];
        for(let i=0;i<userSpecificQuestions.length;i++){

            const inputId = "repsonsesJSON-"+i;

            questionsJSX.push(
                <div className="referenceField" key={"userQuestionField-"+i}>
                    <div id={"userQuestion-"+i}>{userSpecificQuestions[i].question}</div>
                    <div>
                        <input 
                            type="text" 
                            name={inputId} 
                            id={inputId} 
                            className={'col-sm-6 responseJSONItem' + (userSpecificQuestions[i].useCharLimit ? " usesLimit" : "")} 
                            onKeyUp={(event)=>{
                                if(userSpecificQuestions[i].useCharLimit){
                                    this.updateCharacterLengthIndicator(event, inputId);
                                }
                            }}
                        />
                    </div>

                    {
                        userSpecificQuestions[i].useCharLimit ? 
                            <div className="referenceCharacterLimitBlock">
                                Character minimum met: {this.state.characterLengthIndicatorData[inputId] ? this.state.characterLengthIndicatorData[inputId].numChars : 0} 
                                / 
                                {this.state.minCharacterLimit}
                                <div className="lengthIndicatorContainer">
                                    <span 
                                        className={"lengthIndicator-" + i}
                                        style={{
                                            backgroundColor: this.state.characterLengthIndicatorData[inputId] ? this.state.characterLengthIndicatorData[inputId].indicatorColor : "#FFF",
                                            width: this.state.characterLengthIndicatorData[inputId] ? this.state.characterLengthIndicatorData[inputId].indicatorWidth : 0
                                        }}
                                    >
                                        &nbsp;
                                    </span>
                                </div>
                            </div> : 
                        null
                    }                    
                </div>
            );
        }

        return <div>
            {questionsJSX}
        </div>;

    }

    displayMessages(messages) {
        this.setState({
            messagesToDisplay : messages,
            messageBlockDisplayStatus : true
        });
    }

    hideMessages(){
        this.setState({
            messageBlockDisplayStatus : false
        });
    }

    render() {
        return this.state.tokenFound && this.state.reference ? (<div id="referenceInputForm" className="grid-default-dimensions">
            <div>
                Hello <strong>{this.state.reference.first_name} {this.state.reference.last_name}</strong>, Thank you for connecting to the GeoEngineers Job Candidate Reference Tool.  <br /><br />

                <strong>{this.state.candidate.first_name} {this.state.candidate.last_name}</strong> has interviewed with GeoEnigneers, 
                and they have submitted you as a reference in their job application.  
                Please take a moment to review the questions below and enter your responses.  
                Your responses will be confidential and only reviewed by our interviewing team. 
            </div>

            <div className="referenceField">
                <div>Candidate Relationship:</div>
                <div>
         
                    <select value={this.state.reference && this.state.reference.reference_type ? this.state.reference.reference_type : "peer"} name="relationshipType" id="relationshipType" className='col-sm-6' onChange={(event)=>{
                        const selectedValue = event.target.value;
                        const newReferenceState = Utils.copy(this.state.reference);
                        newReferenceState.reference_type = selectedValue;
                        this.setState({
                            reference : newReferenceState
                        });
                    }}>
                        <option value="academic">Academic</option>
                        <option value="peer">Peer</option>
                        <option value="supervisor">Supervisor</option>
                    </select>
                
                </div>
            </div>
            
            <div className="referenceField">
                <div>Preferred Phone:</div>
                <div><input type="text" name="phone" id="phone" className='col-sm-6' /></div>
            </div>
            
            <div className="referenceField">
                <div>Preferred Email:</div>
                <div><input type="text" name="email" id="email" className='col-sm-6' /></div>
            </div>
            
            <div className="referenceField">
                <div>Company Name:</div>
                <div><input type="text" name="companyName" id="companyName" className='col-sm-6' /></div>
            </div>

            {this.renderContactTypeQuestions()}
            
            <div className="referenceField" id="saveReferenceBlock">
                <button name="saveReference" value="saveReference" onClick={()=>{
                    this.validateAndSave();
                }}>Save and submit</button>
            </div>

            {this.state.messageBlockDisplayStatus ? <div className="backdropOverlay">&nbsp;</div> : null}

            <div id="referenceMessageContainer" style={{ display: this.state.messageBlockDisplayStatus ? "block" : "none" }}>
                <div id="referenceMessageHeader">
                    Some fields were not filled out completely, please complete the form before saving
                    <div className="closeIcon" onClick={()=>{
                        this.hideMessages();
                    }}>X</div>
                </div>
                <div id="referenceMessageBody">
                    {this.state.messagesToDisplay.map((thisMessage)=>{
                        return <div className="messageBlockItem" key={Utils.guid()}>{thisMessage}</div>;
                    })}                    
                </div>
                <div id="referenceMessageFooter">
                    <button className="messageCloseButton" onClick={()=>{
                        this.hideMessages();
                    }}>Close</button>
                </div>
            </div>

        </div>) : <div>{this.state.referenceMessage ? this.state.referenceMessage : "Reference not found."}</div>;
    }
}  

export default ReferenceForm;